export const cardInfo = [
  {
    img: "https://source.unsplash.com/800x600/?nature,forest",
    description: "visit small town forest area",
    title: "Ocean Springs",
    author: "Susan"
  },
  {
    img: "https://source.unsplash.com/800x600/?nature,water",
    description: "small forest area",
    title: "Culver City",
    author: "Carlos"
  },
  {
    img: "https://source.unsplash.com/800x600/?forest",
    description: "forest area",
    title: "Elizabethton ",
    author: "Maria"
  }
];
